import { useQuery } from "@tanstack/react-query";
import httpInjectorService from "services/http-injector.service";

export const useSpaceContent = (spaceId) => {
  const numericId = Number(spaceId);

  return useQuery({
    queryKey: ["spaceContent", numericId],
    queryFn: async () => {
      const response = await httpInjectorService.getSpaceContent({
        space_id: numericId,
      });

      return response?.data ?? [];
    },
    enabled: !!numericId,
    retry: false,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
};
